import {Component} from '@angular/core';
import {of} from 'rxjs';

import {ListingsComponent} from '../listings.component';
import {ClientService} from '../../../../services/auth/client.service';
import {ToastService} from '../../../../services/layout/toast.service';
import {ObjectServiceFactory} from '../../../../services/objects/abstractions/objects/object-service.factory';
import {MatDialog} from '@angular/material/dialog';

const fixtureAssistant = {
  id: 'fixture-assistant-base64',
  clientId: 'fixture-client',
  name: 'Base64 Fixture Assistant',
  description: 'Local visual fixture row for data URI thumbnails.',
  enabled: true,
  model: 'gpt-4o-mini',
  image: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI1MCIgdmlld0JveD0iMCAwIDQ4IDUwIj4KICA8cmVjdCB3aWR0aD0iNDgiIGhlaWdodD0iNTAiIHJ4PSIxMiIgZmlsbD0iIzFEMkEzNiIvPgogIDxjaXJjbGUgY3g9IjI0IiBjeT0iMTgiIHI9IjEwIiBmaWxsPSIjNkMzREVEIi8+CiAgPHBhdGggZD0iTTE0IDQwYzMtNi45IDYuOC0xMC40IDEwLTEwLjRzNyAzLjUgMTAgMTAuNEgxNHoiIGZpbGw9IiNEMkM0RkYiLz4KPC9zdmc+Cg==',
  baseUrl: 'https://fixture.local/assistants/base64',
};

const fixtureRemoteAssistant = {
  id: 'fixture-assistant-remote',
  clientId: 'fixture-client',
  name: 'Remote Thumbnail Assistant',
  description: 'Local visual fixture row for remote listing thumbnails.',
  enabled: true,
  model: 'gpt-4o',
  image: 'https://www.markedspartner.no/hubfs/Logomark-Color%20(1).png',
};

const fixtureObjectService = {
  getAllAsync: () => of([fixtureAssistant, fixtureRemoteAssistant]),
  getByIdAsync: () => of(fixtureAssistant),
  saveAsync: (value: typeof fixtureAssistant) => of(value),
};

@Component({
  selector: 'app-listings-visual-fixture',
  standalone: true,
  imports: [ListingsComponent],
  template: `
    <app-listings selectionObjectType="assistants"></app-listings>
  `,
  providers: [
    {
      provide: ObjectServiceFactory,
      useValue: {
        getService: () => fixtureObjectService,
      },
    },
    {
      provide: ClientService,
      useValue: {
        client: {id: 'fixture-client'},
      },
    },
    {
      provide: ToastService,
      useValue: {
        showSuccess: () => undefined,
        showError: () => undefined,
        showInfo: () => undefined,
      },
    },
    {
      provide: MatDialog,
      useValue: {
        open: () => ({
          afterClosed: () => of(undefined),
        }),
      },
    },
  ],
})
export class ListingsVisualFixtureComponent {}
